<div [formGroup]="field.control" [transform]="toDbModel.bind(this)">
  <mat-form-field appearance="outline">
    <mat-label>{{ field.key | translate }}</mat-label>
    <input  matInput
            ignoreInputScroll
            type="text"
            autocomplete="off"
            formControlName="{{field.key}}"
            placeholder="{{ field.key | translate }}" />
  </mat-form-field>

  <div class="translatedFields">
    <ng-container *ngFor="let lang of languages; index as i">
      <mat-form-field appearance="outline">
        <mat-label>{{ lang + 'Translation' | translate }}</mat-label>
        <input  matInput
                ignoreInputScroll
                type="text"
                autocomplete="off"
                formControlName="{{ field.key + '_' + lang }}"
                placeholder="{{ lang + 'Translation' | translate }}" />
      </mat-form-field>
    </ng-container>
  </div>
</div>
